import React, { useEffect, useState } from "react";
import { formatTeacherDate, formatTeacherTime, teacherApi } from "./teacherApi";
import type { TeacherBatch } from "./types";

const TeacherBatches: React.FC = () => {
  const [batches, setBatches] = useState<TeacherBatch[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    teacherApi.myBatches().then(setBatches).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <section className="rounded-[30px] border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-black uppercase tracking-wide text-blue-600">My Batches</p>
        <h2 className="mt-2 text-3xl font-black text-slate-950">Assigned batch schedule</h2>
        <p className="mt-2 text-sm font-bold text-slate-500">
          Yahan sirf wahi batches aayenge jo admin ne is teacher ko assign kiye hain.
        </p>
      </section>

      {loading ? (
        <div className="rounded-[28px] bg-white p-10 text-center text-sm font-bold text-slate-400">Loading batches...</div>
      ) : batches.length === 0 ? (
        <div className="rounded-[28px] bg-white p-10 text-center text-sm font-bold text-slate-400">No assigned batches found.</div>
      ) : (
        <section className="grid gap-5 lg:grid-cols-2">
          {batches.map((batch) => (
            <div key={batch.id} className="rounded-[30px] border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-black text-blue-700">
                    {batch.category || "Course"}
                  </span>
                  <h3 className="mt-3 text-xl font-black text-slate-950">{batch.name}</h3>
                  <p className="mt-1 text-sm font-bold text-slate-500">{batch.courseTitle}</p>
                </div>
                <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-black text-emerald-700">
                  {batch.status}
                </span>
              </div>

              <div className="mt-5 grid gap-3 sm:grid-cols-2">
                <Box label="Start Date" value={formatTeacherDate(batch.startDate)} />
                <Box label="Start Time" value={formatTeacherTime(batch.startTime)} />
                <Box label="Class Days" value={batch.days || "-"} />
                <Box label="Students" value={`${batch.enrolledStudents}/${batch.seats}`} />
              </div>

              <div className="mt-5 rounded-2xl bg-slate-50 p-4">
                <div className="mb-2 flex justify-between text-xs font-black text-slate-500">
                  <span>Seat Occupancy</span>
                  <span>{Math.round((batch.enrolledStudents / Math.max(batch.seats, 1)) * 100)}%</span>
                </div>
                <div className="h-2 rounded-full bg-slate-200">
                  <div
                    className="h-2 rounded-full bg-blue-600"
                    style={{ width: `${Math.min(100, Math.round((batch.enrolledStudents / Math.max(batch.seats, 1)) * 100))}%` }}
                  />
                </div>
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

const Box = ({ label, value }: { label: string; value: string }) => (
  <div className="rounded-2xl bg-slate-50 p-4">
    <p className="text-xs font-bold uppercase tracking-wide text-slate-400">{label}</p>
    <p className="mt-1 text-sm font-black text-slate-900">{value}</p>
  </div>
);

export default TeacherBatches;
